<template>
  <div class="flex flex-column w-full h-full p-2">
    <h1 class="pl-5 text-700 font-normal">{{ $t("mesServices.title") }}</h1>
    <div class="border-round-2xl border-2 border-500 w-11">
      <ul v-if="services.phlSpoolIA" class="list-none p-2 my-0">
        <h2 class="font-normal text-700">{{ $t("mesServices.iaCategory") }}</h2>
        <li class="flex md:w-2">
          <router-link to="/mesServicesIA"
            class="flex w-full no-underline flex-column p-2 align-items-center cursor-pointer text-600 hover:text-900 border-round transition-colors transition-duration-150">
            <i class="pi pi-shopping-bag" style="font-size: 2.5rem;"></i>
            <span class="font-medium text-center p-1 pt-2">{{ $t("mesServices.phlSpoolIA") }}</span>
          </router-link>
        </li>
      </ul>
      <div v-if="!hasAnyService" class="p-5 text-500 text-center">
        {{ $t("mesServices.noServices") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      services: JSON.parse(localStorage.getItem('services') || '{}'),
    };
  },
  computed: {
    hasAnyService() {
      return Object.values(this.services).some(v => v === true);
    },
  },
};
</script>
